import { AlertCircle, Info, CheckCircle, AlertTriangle } from "lucide-react"
import { cn } from "@/lib/utils"

type InfoBoxType = "info" | "warning" | "success" | "error"

interface InfoBoxProps {
  type?: InfoBoxType
  title?: string
  children: React.ReactNode
}

const icons = {
  info: Info,
  warning: AlertTriangle,
  success: CheckCircle,
  error: AlertCircle,
}

const styles = {
  info: "border-blue-500/50 bg-blue-500/10 text-blue-700 dark:text-blue-300",
  warning: "border-yellow-500/50 bg-yellow-500/10 text-yellow-700 dark:text-yellow-300",
  success: "border-green-500/50 bg-green-500/10 text-green-700 dark:text-green-300",
  error: "border-red-500/50 bg-red-500/10 text-red-700 dark:text-red-300",
}

export function InfoBox({ type = "info", title, children }: InfoBoxProps) {
  const Icon = icons[type]

  return (
    <div className={cn("my-4 rounded-lg border p-4", styles[type])}>
      <div className="flex gap-3">
        <Icon className="h-5 w-5 shrink-0 mt-0.5" />
        <div className="flex-1 space-y-2">
          {title && <p className="font-semibold">{title}</p>}
          <div className="text-sm">{children}</div>
        </div>
      </div>
    </div>
  )
}

